<template>

  <v-dialog
    v-model="dialog"
    max-width="900"
    persistent
  >

    <v-card>

      <v-card-title
        class="d-flex justify-center"
      >

        <span class="text-h5 font-weight-bold">

          Establecimientos -
          [{{ config.IdCompania }}]
          {{ config.NombreCompania }}

        </span>

      </v-card-title>


      <v-card-text>

        <!-- ============================================ -->
        <!-- REGISTRAR CODE STORE -->
        <!-- ============================================ -->

        <v-row>

          <v-col
            cols="12"
            sm="2"
          />

          <v-col
            cols="12"
            sm="5"
          >

            <v-text-field
              v-model="codeStore"
              dense
              label="Establecimiento asignado a la campaña"
              outlined
              @keyup.enter="saveStore"
            />

          </v-col>


          <v-col
            cols="12"
            sm="3"
          >

            <v-btn
              style="
                background-color: rgb(204 33 40);
                color: white !important;
              "
              @click="saveStore"
            >

              AGREGAR

            </v-btn>

          </v-col>

        </v-row>
        <v-alert
          v-show="errorAlert"
          type="warning"
          text
          class="mt-3"
        >
          {{ msgErrorAlert }}
        </v-alert>

        <!-- ============================================ -->
        <!-- LISTADO -->
        <!-- ============================================ -->

        <v-data-table
          :headers="headers"
          :items="stores"
          class="mt-4"
        >

          <!-- CodeStore -->
          <template
            v-slot:item.CodeStore="{ item }"
          >

            <div class="text-center">

              {{ item.CodeStore }}

            </div>

          </template>


          <!-- TokenKey -->
          <template
            v-slot:item.TokenKey="{ item }"
          >

            <div class="text-center">

              <v-tooltip bottom>

                <template
                  v-slot:activator="{ on, attrs }"
                >

                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="copyToken(item.TokenKey)"
                  >

                    <v-icon>
                      mdi-content-copy
                    </v-icon>

                  </v-btn>

                </template>

                <span>
                  Copiar Token
                </span>

              </v-tooltip>

            </div>

          </template>


          <!-- Estado -->
          <template
            v-slot:item.Active="{ item }"
          >

            <div
              class="d-flex justify-center"
            >

              <v-switch
                v-model="item.Active"
                inset
                @change="changeStatus(item)"
              />

            </div>

          </template>

        </v-data-table>

      </v-card-text>


      <v-card-actions>

        <v-spacer />

        <v-btn
          text
          @click="close"
        >

          CERRAR

        </v-btn>

      </v-card-actions>

    </v-card>

  </v-dialog>

</template>


<script>

  export default {

    props: {

      value: {

        type: Boolean,

        default: false,

      },


      config: {

        type: Object,

        default: () => ({}),

      },

    },


    data () {

      return {

        codeStore: '',
        errorAlert: false,
        msgErrorAlert: '',
        headers: [

          {
            text: 'Código Establecimiento',
            value: 'CodeStore',
            align: 'center',
          },

          {
            text: 'Token',
            value: 'TokenKey',
            align: 'center',
            sortable: false,
          },

        ],

      }

    },


    computed: {

      dialog: {

        get () {

          return this.value

        },


        set (value) {

          this.$emit(
            'input',
            value,
          )

        },

      },


      stores () {

        return this.$store.state
          .alianzas
          .stores || []

      },

    },


    watch: {

      dialog (value) {

        if (value) {

          this.codeStore = ''

          this.errorAlert = false

          this.msgErrorAlert = ''

          this.loadStores()

        }

      },

    },


    methods: {

      loadStores () {

        if (!this.config.Id) {

          return

        }


        this.$store.dispatch(
          'alianzas/getStores',
          this.config.Id,
        )

      },


      async saveStore () {

        this.errorAlert = false
        this.msgErrorAlert = ''

        try {

          await this.$store.dispatch(
            'alianzas/saveStore',
            {
              IdAlianza: this.config.Id,
              CodeStore: this.codeStore,
            },
          )

          await this.loadStores()

          this.codeStore = ''

          this.errorAlert = false
          this.msgErrorAlert = ''

        } catch (error) {

          this.errorAlert = true

          this.msgErrorAlert =
            error.response &&
            error.response.data &&
            error.response.data.message
              ? error.response.data.message
              : 'No fue posible registrar el CodeStore.'

        }

      },


      async changeStatus (item) {

        await this.$store.dispatch(
          'alianzas/changeStoreStatus',
          {
            Id: item.Id,
            Active: item.Active,
          },
        )


        this.loadStores()

      },


      async copyToken (token) {

        if (!token) {

          return

        }


        try {

          await navigator.clipboard.writeText(
            token,
          )

          this.$toast.success(
            'Token copiado',
          )

        } catch (e) {

          const input =
            document.createElement('input')

          input.value = token

          document.body.appendChild(
            input,
          )

          input.select()

          document.execCommand(
            'copy',
          )

          document.body.removeChild(
            input,
          )

          this.$toast.success(
            'Token copiado',
          )

        }

      },


      close () {

        this.dialog = false

      },

    },

  }

</script>
